import { useAuthStore } from '../stores/authStore'

import { API_CONFIG } from '../lib/config'

interface PrintBarcodeRequest {
    quantity: number
    size: '40x20' | '50x25' | '60x30'
}

interface PrintBarcodeResponse {
    pngDataUrl: string
    zpl: string
    product: {
        id: string
        sku: string
        name: string
        barcode: string
        price: number
    }
    printInfo: {
        quantity: number
        size: string
        dimensions: {
            width: number
            height: number
        }
        barcodeType: string
    }
}

export async function printBarcode(
    productId: string,
    request: PrintBarcodeRequest
): Promise<PrintBarcodeResponse> {
    const { accessToken } = useAuthStore.getState()

    if (!accessToken) {
        throw new Error('Yetkilendirme gerekli')
    }

    const response = await fetch(`${API_CONFIG.BASE_URL}/api/barcodes/${productId}/print-label`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
    })

    if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.error?.message || 'Barkod oluşturulamadı')
    }

    return response.json()
}

